import React from "react";
import { useDropzone } from "react-dropzone";

const dropZone = {
  padding: "10px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "13px",
  marginBottom: "10px",
};

const para = {
  margin: "0px",
  paddingBottom: "5px",
};

const DropZone = (props) => {
  const { handleChangeFile } = props;
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      accept: {
        "image/jpeg": [],
        "image/png": [],
        "application/pdf": [],
      },
      onDrop: handleChangeFile,
      multiple: false,
      maxSize: 4000000,
      maxFiles: 1,
    });

  const acceptedFileItems = acceptedFiles.map((file) => {
    console.log("acceptedFileItems", file);
    return <div style={{ paddingBottom: "10px" }}>{file.path}</div>;
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => {
    console.log("file", file);
    return <p>File is not supported</p>;
  });

  return (
    <section className="container" style={{cursor:"pointer"}}>
      <div {...getRootProps({ className: "dropzone", style: dropZone })}>
        <input {...getInputProps()} multiple={false} />
        <p style={para}>Drag 'n' drop file here, or click to select file</p>
        <em style = {{fontStyle:"normal"}}>(Only *.jpeg, *.png and *.pdf file will be accepted)</em>
      </div>
      <aside>
        {/* <em>{acceptedFileItems}</em> */}
        <em style={{ color: "red" }}>{fileRejectionItems}</em>
      </aside>
    </section>
  );
};

export default DropZone;
